export default class cliente{
	constructor($scope,
				$routeParams,
				method,
                clientesService,
				$location,
                $uibModal,
                toastr
				){
		this.scope    = $scope;
		this.location = $location;
		this.toastr = toastr;
        this.modal = $uibModal;
		switch (method) {
			case 'list':
				this.list(clientesService);
			break;
			case 'new':
				this.create(clientesService);
			break;
			case 'view':
				this.view($routeParams,
                    clientesService);
			break;
		}
	}

	list(clientesService){

        let self = this.scope;
        clientesService.getAllList().then((resp, err) => {
            self.clientes = resp.data.message;
		});

        self.getItemPage = (item) => {
            let index = self.clientes.indexOf(item);
            let pageNumber = Math.floor(index / 5) + 1;
            return pageNumber;
        };

        self.eliminar = this.eliminar.bind(this, clientesService);
        /*this.scope.inAction = false;
		this.scope.eliminar = (id, index) => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                clientesService.delete({_id: id}).then((resp) => {
                    this.toastr.success('Cliente eliminado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    window.location.reload();
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al eliminar el cliente!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
		};*/
	}

	create(clientesService){

        this.scope.inAction = false;
		this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                clientesService.save(this.scope.newcliente).then((resp) => {
                    this.toastr.success('Cliente creado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/cliente');
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error( 'Error al crear el cliente!','Error', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
		};
	}

	view($routeParams,
         clientesService){

		this.scope.aux = {};
        clientesService.getById({_id: $routeParams.id}).then((resp) => {
			this.scope.cliente = resp.data.message;
		}).catch((er) => {
			console.log(er);
		});

        this.scope.inAction = false;
		this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                clientesService.update(this.scope.cliente).then((resp) => {
                    this.toastr.success('Cliente modificado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/cliente');
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al modificar el cliente!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
		};
	}

    eliminar(service,object, page, index) {
        let self = this;
        let templateModal = `
			    <div class="modal-content">
			      <div class="modal-header">
			        <h4 class="modal-title" id="myModalLabel">Eliminar Cliente</h4>
			      </div>
			      <div class="modal-body">
                		¿Quiere eliminar al cliente: {{ctr.nombre}}?
			      </div>
			      <div class="modal-footer">
			        <button type="button" class="btn btn-default" ng-click="ctr.no()">NO</button>
			        <button type="button" class="btn btn-primary" ng-click="ctr.si()">SI</button>
			      </div>
			    </div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function () {
                let vm = this;
                vm.nombre = object.nombre;
                this.no = () => {
                    let data = {
                        delete: false
                    };
                    modal.close(data);
                };

                this.si = () => {
                    let data = {
                        delete: true,
                        index: (page - 1) * 5 + index
                    };
                    modal.close(data);
                };
            },
            controllerAs: 'ctr',
            size: 'md'
        });

        modal.result.then((resp) => {
            if (resp.delete) {
                let indexObject = resp.index;
                self.inAction = true;
                service.delete({_id: object._id}).then((resp) => {
                    self.scope.clientes.splice(indexObject, 1);
                    self.inAction = false;
                    this.toastr.success('Cliente eliminado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                })
                    .catch((err) => {
                        self.inAction = false;
                        this.toastr.error('Error al eliminar al cliente!','Error',  {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }

        }, (exit) => {
            console.log('modal close');
        });
    }
}


// WEBPACK FOOTER //
// ./app/js/controllers/cliente/cliente.js